<template>
    <proposal-agreements-provider
        v-slot="{
            campaign,
            proposal,
            proposalStep,
            patchProposalStep,
            goNextStep,
            goPreviousStep,
            isLoading,
            isCompletingProposal,
            errors,
            errorMessage,
            usesAlternateTerms,
        }"
        style="height: 100%">
        <proposal-agreements-view
            :campaign="campaign"
            :proposal-step="proposalStep"
            :proposal="proposal"
            :is-loading="isLoading"
            :is-completing-proposal="isCompletingProposal"
            :errors="errors"
            :error-message="errorMessage"
            :uses-alternate-terms="usesAlternateTerms"
            @go-next-step="goNextStep"
            @go-previous-step="goPreviousStep"
            @patch-step="patchProposalStep"
        />
    </proposal-agreements-provider>
</template>

<script>
    import ProposalAgreementsProvider from '../providers/proposal-steps/ProposalAgreementsProvider';
    import ProposalAgreementsView from '../data-views/proposals/ProposalAgreementsView';
    export default {
        name:       'ProposalAgreementsRouterView',
        components: {
            ProposalAgreementsView,
            ProposalAgreementsProvider,
        },
    };
</script>
